import { get, post } from "./request";

// const PATH_API = '/websiteApi';
const PATH_API = {
  dev: "//api-work-test.jdazcn.com/websiteApi",
  test: "//api-work-test.jdazcn.com/websiteApi",
  pre: "//api-work-pre.jdazcn.com/websiteApi",
  prod: "//www.jdallianz.com/websiteApi",
  //@ts-ignore
}[process.env.REACT_APP_MODE];

export const fetchFileList = (params: any) => {
  return post({
    url: `${PATH_API}/website/web/file/queryForList`,
    body: params,
  });
};

export const fetchFileGroupList = (params: any) => {
  return post({
    url: `${PATH_API}/website/web/file/queryForGroup`,
    body: params,
  });
};

export const fetchCampaignList = () => {
  return get({
    url: `${PATH_API}/website/web/campaign/query/list`,
    params: {},
  });
};

export const fetchNewsJson = (url: any) => {
  return get({
    url: `${PATH_API}${url}`,
    params: {},
    isJson: true,
  });
};

export const prodictQuery = (url: any) => {
  return get({
    url: `${PATH_API}${url}`,
    params: {},
    isJson: true,
  });
};

export const intermediaryAgenciesQuery = (params: any) => {
  return post({
    url: `${PATH_API}/website/web/intermediaryAgencies/query`,
    body: params,
  });
};

//总经理接待日查询接口
export const listOpenDay = (params: any) => {
  return post({
    url: `${PATH_API}/website/web/openDay/listOpenDay`,
    body: params,
  });
};

//招标公告查询
export const biddingNoticeQuery = (params: any) => {
  return post({
    url: `${PATH_API}/website/web/biddingNotice/query`,
    body: params,
  });
};

//招标公告id查询
export const queryById = (params: any) => {
  return post({
    url: `${PATH_API}/website/web/biddingNotice/queryById?noticeId=${params.noticeId}`,
    body: params,
  });
};
